import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  DataService,
  PamlabApiServiceService,
  SnackbarService,
  ScreenSizeService,
  RouteService,
} from '@/shared/services';
import { Subscription } from 'rxjs';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { ProgramBottleneckCourseExtended } from '../../../../../server/types';
import { ProgramBottleneckReturn } from 'src/server/types/program-bottleneck-course';

@Component({
  selector: 'program-bottleneck-content',
  templateUrl: './program-bottleneck-content.component.html',
  styleUrls: ['./program-bottleneck-content.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'),
      ),
    ]),
  ],
  standalone: false,
})
export class ProgramBottleneckContentComponent implements OnInit, OnDestroy {
  public dataPending!: boolean;
  private subscription: Subscription = new Subscription();
  programBottleneckData!: ProgramBottleneckReturn;
  displayedColumns = [
    'college',
    'course_code',
    'course_name',
    'pass_rate',
    'program',
  ];
  expandedElement!: ProgramBottleneckCourseExtended | null;
  mobileView: boolean = false;

  constructor(
    private dataService: DataService,
    private snackbarService: SnackbarService,
    private apiService: PamlabApiServiceService,
    private screenSizeService: ScreenSizeService,
    private routeService: RouteService,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.dataService.getData().subscribe((dataStream) => {
        if (dataStream.data) {
          this.programBottleneckData =
            dataStream.data as ProgramBottleneckReturn;
        }

        if (dataStream.error) {
          this.programBottleneckData.courses = [];
          this.snackbarService.open(dataStream.error.message, 'error');
        }
      }),
    );

    this.subscription.add(
      this.dataService.getPendingData().subscribe((pending) => {
        this.dataPending = pending;
      }),
    );

    this.subscription.add(
      this.screenSizeService.screenView$.subscribe((view) => {
        this.mobileView = view === 'mobile';
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getSelectedFilterStr() {
    const { college, program, year, term } = this.programBottleneckData.filters;
    return `College: ${college} | Program: ${program} | Year: ${year} | Semester: ${term}`;
  }

  navigateToGlossaryOfTerms(termValue: string) {
    this.routeService.navigateNewTab('/glossary-of-terms', {
      term_value: termValue,
    });
  }
}
